import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import ListItem from 'components/place/index/list_item';
import ListHeader from 'components/place/index/list_header';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const Index = ({ places, sortBy, onSortChange, loading }) => {
  return (
    <List>
      <ListHeader sortBy={sortBy} onSortChange={onSortChange} />
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {places.places.map((place) => (
          <ListItem key={place.id} place={place} />
        ))}
      </LoaderContainer>
      {!loading && places.places.length === 0 && (
        <IndexListItem>
          <InfoContainer>
            <FormattedMessage id="empty.places.title.short" />
          </InfoContainer>
        </IndexListItem>
      )}
    </List>
  );
};

export default Index;
